import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import SolidButton from '../../../../../Buttons/SolidButton';
const DestructiveConfirmButton = (_param)=>/*#__PURE__*/ {
    var { children  } = _param, rest = _object_without_properties(_param, [
        "children"
    ]);
    return React.createElement(SolidButton, _extends({
        size: "large",
        variant: "destructive-red"
    }, rest), children);
};
DestructiveConfirmButton.displayName = 'DestructiveConfirmButton';
export default DestructiveConfirmButton;
